import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { backendApi } from '@ui/services/api/config';

type HTTPMethods = 'post' | 'get' | 'put' | 'patch' | 'delete';

interface IResponse<T> {
  error?: any;
  ok: boolean;
  data?: T;
}

export async function request<T = any>(
  method: HTTPMethods,
  endpoint: string,
  params?: any,
  options = {},
): Promise<IResponse<T>> {
  const data: AxiosRequestConfig = {};
  if (method === 'get') {
    data.params = params;
  } else {
    data.data = params;
  }

  return axios({
    method,
    baseURL: backendApi,
    url: endpoint,
    ...data,
    ...options,
  } as AxiosRequestConfig)
    .then((response: AxiosResponse<T>) => ({
      ok: true,
      data: response.data,
    }))
    .catch((err: any) => {
      console.error('request_error', err);
      return {
        ok: false,
        error: err,
      };
    });
}



// WEBPACK FOOTER //
// ./src/api/v2/api.ts